import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './About2.css';
import InteractiveMap from './InteractiveMap/InteractiveMap';

const About2 = () => {
    const { t } = useTranslation('about');

    return (
        <div className="aboutContainer">
            <div className='HomeComponent'>
                <div className="titleContainer2">
                    <h1 className="title">{t('partners')}</h1>
                </div>
            </div>
            <div className="aboutContent">
                <div className="aboutImage">
                    <InteractiveMap />
                </div>
            </div>
        </div>
    );
};

export default About2;
